<template>
  <div class="onboarding-tooltip">
    <slot></slot>
    <div
      :class="`onboarding-tooltip__content onboarding-tooltip__content_${placement}`"
      v-if="showTooltip"
    >
      <p class="onboarding-tooltip__title">
        {{ title }}
      </p>
      <p class="onboarding-tooltip__text">
        {{ text }}
      </p>
      <svg class="onboarding-tooltip__arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="48" viewBox="0 0 13 48" fill="none">
        <foreignObject x="-130" y="-129.5" width="272.999" height="307"><div xmlns="http://www.w3.org/1999/xhtml" style="backdrop-filter:blur(65px);clip-path:url(#bgblur_0_12101_3263_clip_path);height:100%;width:100%"></div></foreignObject><path data-figma-bg-blur-radius="130" fill-rule="evenodd" clip-rule="evenodd" d="M12.9971 47.5C12.9971 45.7875 13.0056 44.0755 12.9871 42.363C12.9691 40.724 12.9436 38.8896 12.3421 37.2945C11.692 35.5716 10.5555 34.4309 9.21799 33.2832C8.25597 32.457 6.20343 30.834 5.21241 30.0437C4.39989 29.3969 2.79386 28.1308 2.01684 27.4395C1.03932 26.5692 0.000297809 25.4936 0.000297827 23.9995C0.000297844 22.5054 1.03932 21.4303 2.01584 20.5605C2.79236 19.8692 4.39939 18.6031 5.21141 17.9558C6.20243 17.1665 8.25497 15.5435 9.21699 14.7168C10.5545 13.5671 11.691 12.4284 12.3411 10.706C12.9411 9.11044 12.9681 7.27548 12.9861 5.63747C13.0046 3.92448 12.9961 2.21249 12.9961 0.5" fill="#F4F4F4"/>
        <defs>
          <clipPath id="bgblur_0_12101_3263_clip_path" transform="translate(130 129.5)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9971 47.5C12.9971 45.7875 13.0056 44.0755 12.9871 42.363C12.9691 40.724 12.9436 38.8896 12.3421 37.2945C11.692 35.5716 10.5555 34.4309 9.21799 33.2832C8.25597 32.457 6.20343 30.834 5.21241 30.0437C4.39989 29.3969 2.79386 28.1308 2.01684 27.4395C1.03932 26.5692 0.000297809 25.4936 0.000297827 23.9995C0.000297844 22.5054 1.03932 21.4303 2.01584 20.5605C2.79236 19.8692 4.39939 18.6031 5.21141 17.9558C6.20243 17.1665 8.25497 15.5435 9.21699 14.7168C10.5545 13.5671 11.691 12.4284 12.3411 10.706C12.9411 9.11044 12.9681 7.27548 12.9861 5.63747C13.0046 3.92448 12.9961 2.21249 12.9961 0.5"/>
          </clipPath></defs>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingTooltip',
  props: {
    showTooltip: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'left',
    },
  },
};
</script>

<style lang="scss">
.onboarding-tooltip {
  position: relative;
}

.onboarding-tooltip__content {
  position: absolute;
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 16px;
  background: #f4f4f4;
  width: 230px;
  z-index: 1;

  &_right {
    left: calc(100% + 20px);
    top: 50%;
    transform: translateY(-50%);
    .onboarding-tooltip__arrow{
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &_left {
    right: calc(100% + 20px);
    top: 50%;
    transform: translateY(-50%);
    .onboarding-tooltip__arrow{
      right: -12px;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
    }
  }
  &_top {
    bottom: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    .onboarding-tooltip__arrow{
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%) rotate(-90deg);
    }
  }
}
.onboarding-tooltip__arrow{
  position: absolute;
}
.onboarding-tooltip__title{
  color: var(--solid-black-purple);
  font-family: 'Inter';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}
.onboarding-tooltip__text{
  color: var(--solid-dark-purple);
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>
